import dayjs, { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export const decimalMinutesToTimeString = (decimalMinutes: number, formatType: 'clock' | 'words' = 'words', includeSeconds: boolean = false) => {
  const hours = Math.floor(decimalMinutes / 60)
  const minutes = Math.floor(decimalMinutes - hours * 60)
  const seconds = Math.round((decimalMinutes - Math.floor(decimalMinutes)) * 60)

  let timeString = ``
  if (formatType == 'clock') timeString = `${hours > 0 ? hours + ':' : ''}${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`

  if (formatType == 'words') {
    timeString += `${hours > 0 ? hours + 'hr ' : ''}${minutes < 10 ? '0' : ''}${minutes}m`
    if (includeSeconds) timeString += ` ${seconds < 10 ? '0' : ''}${seconds}s`
  }

  return timeString
}

export const getModifedTime = (start: string, duration: number, format: 'add' | 'subtract'): Dayjs => {
  let formatType = `hh:mm ${start.includes('AM') || start.includes('PM') ? 'A' : ''}`
  const newTime = dayjs(start, formatType)[format](duration, 'minute')

  return newTime
}

export const formatDayJS = (day: Dayjs, showAP: boolean = false): string => {
  return day.format(`${showAP ? 'hh:mm A' : 'HH:mm'}`)
}

const checkSameDay = (ts1: number, ts2: number, locale: string = 'en-NZ') => {
  return new Date(ts1).toLocaleDateString(locale) === new Date(ts2).toLocaleDateString(locale)
}

const checkSameYear = (ts1: number, ts2: number) => {
  return new Date(ts1).getFullYear() === new Date(ts2).getFullYear()
}

const checkSameMonth = (ts1: number, ts2: number) => {
  return new Date(ts1).getMonth() === new Date(ts2).getMonth() && checkSameYear(ts1, ts2)
}

export const DateComparisons = { checkSameDay, checkSameMonth, checkSameYear }
